import React, { useState } from 'react'
import CustomAppBar from '../components/CustomAppBar'
import { Box, Checkbox, Typography, Button } from '@mui/material'
import { useNavigate, Link } from 'react-router-dom';
import PrimaryButton from '../components/PrimaryButton';
import Navbar from '../components/Navbar';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import SectionBanner from '../components/SectionBanner';
import CloseIcon from '@mui/icons-material/Close';
import HeartListItem from '../components/HeartListItem';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { addGroup, updateTempGroupHearts, updateTempGroupID, removeHeartFromGroup, updateGroup, updateGroupOnReduxAndServer, addGroupToReduxAndServer } from '../redux/groupSlice';
import { updateHeartOnReduxAndServer } from '../redux/heartSlice';
import { generateGroupID } from '../validation/utils';
// validation
import { Formik, ErrorMessage, Field, Form } from 'formik';
import { addUserToReduxAndServer } from '../redux/userSlice';
import { DEFAULT_HEART_COLOR_NUMBER, MQTT_TOPIC_PREFIX } from '../constants';
import { publishMessage } from '../api/mqtt';
import SectionBanner2 from '../components/SectionBanner2';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { GroupSchema, HeartSchema, UserSchema } from 'lumas-shared-schemas';

function NewGroupAddHearts() {
    // get hearts from the store
    const storeHearts = useSelector((state) => state.heart.hearts);
    const tempGroupHearts = useSelector((state) => state.group.tempGroupHearts);
    const tempGroupName = useSelector((state) => state.group.tempGroupName);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.user);
    const groups = useSelector((state) => state.group.groups);

    console.log("temp group name: ", tempGroupName);

    const handleFormSubmit = (values, {setSubmitting}) => {
        // TODO: add a spinner while waiting for the response from the server?
        console.log("Values", values);
        const groupID = generateGroupID(tempGroupName);
        dispatch(updateTempGroupID(groupID));
    
        // remove selected hearts from their old groups (if any)
        selectedHearts.map((heart) => {
            const oldGroup = groups.find((group) => group.id === heart.group);
            if(oldGroup) {
                const updatedOldGroup = GroupSchema.parse({
                    ...oldGroup, 
                    hearts: oldGroup.hearts.filter((heartID) => heartID !== heart.id)
                });
                dispatch(updateGroupOnReduxAndServer({id: oldGroup.id, updatedGroup: updatedOldGroup}))
                console.log("removed heart from old group! old group:", updatedOldGroup);

            }
            
            // Send DATABASE_UPDATE to old group to sync database group member values (including "None" group)
            publishMessage(`${MQTT_TOPIC_PREFIX}${heart.group}/dbUpdate`, "DATABASE_UPDATE", false);

        });
    
        // update group of the heart in the heart store
        selectedHearts.map((heart) => {
            const updatedHeart = HeartSchema.parse({
                ...heart, 
                group: groupID
            });
            dispatch(updateHeartOnReduxAndServer({id: heart.id, updatedHeart: updatedHeart}));
        });

        // get just the IDs of the selected hearts
        const selectedHeartIDs = selectedHearts.map((heart) => heart.id);
    
        // add the new group to the store with selected hearts
        const newGroup = GroupSchema.parse({
            id: groupID,
            name: tempGroupName,
            color: DEFAULT_HEART_COLOR_NUMBER,
            colorMode: 'Solid',
            members: [
                {email: user.email, admin: true}, // current user is the admin
            ],
            hearts: selectedHeartIDs,
        });
        dispatch(addGroupToReduxAndServer(newGroup));   

        // Create Group MQTT topic and publish default colorNumber message
        publishMessage(`${MQTT_TOPIC_PREFIX}${groupID}/color`, DEFAULT_HEART_COLOR_NUMBER.toString());

        // Send DATABASE_UPDATE to group to sync database group member values
        publishMessage(`${MQTT_TOPIC_PREFIX}${groupID}/dbUpdate`, "DATABASE_UPDATE", false);

        // update the user with the new group, validating against schema
        const updatedUser = UserSchema.parse({
            ...user, 
            groups: [...user.groups, groupID]
        });
        dispatch(addUserToReduxAndServer(updatedUser));

        console.log("New group created! Group ID: ", groupID);
        console.log("added updated user to store: ", updatedUser); 

        navigate('/new-group/done');
        
        setSubmitting(false); // Set submitting to false
    }

    // state for selected hearts
    const [selectedHearts, setSelectedHearts] = useState([]);
    const handleCheckboxChange = (heartID) => {

        // if the heart already in selectedHearts, remove it
        if(selectedHearts.find(heart => heart.id === heartID)) {
            const updatedHearts = selectedHearts.filter((heart) => heart.id !== heartID);
            setSelectedHearts(updatedHearts);
            console.log("removed")
        } else {
            // otherwise, add it
            console.log("heart added!")
            const newHeart = storeHearts.find((heart) => heart.id === heartID);
            setSelectedHearts([...selectedHearts, newHeart]);
        }
    } 

    return (
        <AppContainer>
            <Formik 
                initialValues={{ }}
                onSubmit={handleFormSubmit}
            >
            {({ isSubmitting, errors, touched }) => (
                <Form>
                    <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight }}>
                        <CustomAppBar />
                        {/* Box to fill space, pushing button to bottom of screen */}
                        <Box style={{ flex: 1 }}>
                            <Navbar rightButtonIcon={<CloseIcon /> } rightButtonOnClick={() => {navigate('/home')}} />
                            <TextContainer>
                                <Typography variant='h5'>Add hearts to group</Typography>
                                <Typography variant='body2' sx={{fontStyle: 'italic', fontSize: '14px'}}>(Optional) Select the hearts you want to add to the group.</Typography>
                            </TextContainer>
                            <SectionBanner2 text={"Your Hearts"} customStyles={{marginTop: "20px"}} />
                            <TextContainer>
                                {/* List your hearts here */}
                                {storeHearts.map((heart, index) => (
                                    <HeartListItem key={index} text={heart.name} onChange={() => handleCheckboxChange(heart.id)} />
                                ))}
                            </TextContainer>
                        </Box>
                        {/* Button at the bottom of the screen */}
                        <TextContainer customStyles={{marginBottom: '40px'}}>
                            <Button 
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                                sx={{width: '100%'}}
                            >
                                Create Group
                            </Button>
                            {/* <PrimaryButton text={"Next"} customStyles={{width: '100%'}} onClick={handleNextClick}/> */}
                        </TextContainer>

                    </Box>
                </Form>
            )}
            </Formik>
        </AppContainer>
    )
}
    
export default NewGroupAddHearts